export default {
  selectedChannelIndex: null
}

